import { render, staticRenderFns } from "./IntegrationBox.vue?vue&type=template&id=45a8af1a&scoped=true&"
import script from "./IntegrationBox.vue?vue&type=script&lang=js&"
export * from "./IntegrationBox.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationBox.vue?vue&type=style&index=0&id=45a8af1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8af1a",
  null
  
)

export default component.exports